export default __webpack_public_path__ + "static/media/curve3.a4c58eae.svg";